// import React, { useState, lazy } from 'react';
// import { Card, ListGroup } from 'react-bootstrap';
// import { indianTimeZone, dateFormate } from '../../../utils/helper';
// const ModalForms = lazy(() => import('../../Shared/Modals'));

// const MessageTypeList = ({ message }) => {
//   const [showModal, setShowModal] = useState(false);
//   const isBot = message?.origin === 'INBOUND';

//   try {
//     const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

//     function listItems() {
//       let options = [];
//       try {
//         options = message?.content?.items[0]?.options;
//       } catch {
//         options = [];
//       }

//       return (
//         <ListGroup>
//           {options?.map((item, index) => {
//             return <ListGroup.Item key={index}>{item?.title}</ListGroup.Item>;
//           })}
//         </ListGroup>
//       );
//     }
//     function getHeaderName() {
//       try {
//         return message?.content?.global_buttons[0]?.title;
//       } catch {
//         return 'List';
//       }
//     }
//     return (
//       <>
//         <ModalForms
//           show={showModal}
//           handleClose={(e) => {
//             setShowModal(false);
//           }}
//           modalBody={listItems('userDetails')}
//           modalHeader={getHeaderName()}
//           modalId={'listItems'}
//           modalclassName={''}
//           size="sm"
//         />
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: isBot ? 'flex-start' : 'flex-end',
//             marginBottom: '14px',
//           }}
//         >
//           <Card
//             style={{
//               minWidth: 250,
//               width: 275,
//               maxWidth: 250,
//               background: isBot ? '#eee' : 'rgb(238, 238, 238)',
//               // : 'linear-gradient(90deg, rgba(112,121,245,1) 0%, rgba(6,55,144,1) 100%)',
//               color: isBot ? '#000' : 'black',
//               borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
//               boxShadow: '3px 3px 6px #ccc',
//             }}
//           >
//             <Card.Header style={{ padding: '8 !important' }}>
//               <>
//                 <div
//                   style={{
//                     fontSize: '16px',
//                     fontWeight: '500',
//                     textAlign: 'left',
//                     position: 'relative',
//                   }}
//                 >
//                   {message?.content?.title || message?.content?.body}
//                 </div>
//               </>
//             </Card.Header>
//             <Card.Footer>
//               <div
//                 style={{
//                   // display: 'flex',
//                   width: '100%',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   flexDirection: 'row',
//                   padding: '8px',
//                 }}
//               >
//                 <div
//                   style={{ textAlign: 'center', alignItems: 'center', color: 'rgb(238, 238, 238)' }}
//                 >
//                   <p
//                     style={{ display: 'inline-block', margin: '0', fontSize: '14px', color: 'black' }}
//                   >
//                     1 Page
//                   </p>
//                   <p
//                     style={{ display: 'inline-block', margin: '0', fontSize: '14px', color: 'black' }}
//                   >
//                     | 24 kb
//                   </p>
//                   <p
//                     style={{ display: 'inline-block', margin: '0', fontSize: '14px', color: 'black' }}
//                   >
//                     | PDF
//                   </p>
                  {/* <p style={{ margin: '0 8px 0 0', display: 'inline', fontSize: '14px',color:'black' }}>1 Page</p>
        <p style={{ margin: '0 8px', display: 'inline', fontSize: '14px',color:'black' }}>| 24 kb</p>
        <p style={{ margin: '0', display: 'inline', fontSize: '14px',color:'black' }}>| PDF</p> */}
                {/* </div>
                <div style={{ float: 'right' }}>
                  <p style={{ fontSize: '11px' }}>
                    <span style={{ marginRight: '4px', color: 'black' }}>
                      {!isBot
                        ? message?.status?.type?.charAt(0).toUpperCase() +
                        message?.status?.type?.slice(1).toLowerCase()
                        : null}
                    </span>
                    {timestamp}
                  </p>
                </div>
              </div>
            </Card.Footer>
          </Card>
        </div>
      </>
    );
  } catch {
    return <>None</>
  }

};
export default MessageTypeList; */}



import React, { useState, lazy } from 'react';
import { Card, ListGroup, Button } from 'react-bootstrap';
import { indianTimeZone, dateFormate } from '../../../utils/helper';

const ModalForms = lazy(() => import('../../Shared/Modals'));

const MessageTypeList = ({ message }) => {
  const [showModal, setShowModal] = useState(false);
  const [showList, setShowList] = useState(false); // State to manage list visibility
  const isBot = message?.origin === 'INBOUND';

  const timestamp = dateFormate(indianTimeZone(isBot ? message?.created_at : message?.status?.timestamp), 'DD-MM-YYYY h:mm A');

  function listItems() {
    let options = [];
    try {
      options = message?.content?.items[0]?.options;
    } catch {
      options = [];
    }

    return (
      <ListGroup>
        {options?.map((item, index) => (
          <ListGroup.Item key={index}>{item?.title}</ListGroup.Item>
        ))}
      </ListGroup>
    );
  }

  function getHeaderName() {
    try {
      return message?.content?.global_buttons[0]?.title;
    } catch {
      return 'List';
    }
  }

  return (
    <>
      <ModalForms
        show={showModal}
        handleClose={() => setShowModal(false)}
        modalBody={listItems('userDetails')}
        modalHeader={getHeaderName()}
        modalId={'listItems'}
        modalclassName={''}
        size="sm"
      />
      <div
        style={{
          display: 'flex',
          justifyContent: isBot ? 'flex-start' : 'flex-end',
          marginBottom: '14px',
        }}
      >
        <Card
          style={{
            minWidth: 250,
            width: 275,
            maxWidth: 250,
            background: isBot ? '#eee' : 'rgb(238, 238, 238)',
            color: isBot ? '#000' : 'black',
            borderRadius: isBot ? '12px 12px 12px 0px' : '12px 12px 0px 12px',
            boxShadow: '3px 3px 6px #ccc',
          }}
        >
          <Card.Header style={{ padding: '8px' }}>
            <div
              style={{
                fontSize: '16px',
                fontWeight: '500',
                textAlign: 'left',
                position: 'relative',
              }}
            >
              {message?.content?.title || message?.content?.body}
            </div>
          </Card.Header>
          {/* <Card.Body>
            <div>
              {message?.content?.body}
            </div>
          </Card.Body> */}
          <Card.Footer>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <Button
                variant="primary"
                onClick={() => setShowList(prev => !prev)}
                style={{ marginBottom: '8px' }}
              >
                {showList ? 'Hide List' : 'View List'}
              </Button>
              {showList && listItems()}
            </div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
              }}
            >
              <div style={{ color: 'rgb(238, 238, 238)' }}>
              </div>
              <div>
                <p style={{ fontSize: '11px' }}>
                  <span style={{ marginRight: '4px', color: 'black' }}>
                    {!isBot
                      ? message?.status?.type?.charAt(0).toUpperCase() +
                        message?.status?.type?.slice(1).toLowerCase()
                      : null}
                  </span>
                  {timestamp}
                </p>
              </div>
            </div>
          </Card.Footer>
        </Card>
      </div>
    </>
  );
};

export default MessageTypeList;


